var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrash, faShoppingCart, faArrowLeft, faFileImport, } from "@fortawesome/pro-light-svg-icons";
library.add(faTrash, faShoppingCart, faArrowLeft, faFileImport);
var DynamicButton = function (_a) {
    var alingSelf = _a.alingSelf, implicitAction = _a.implicitAction, text = _a.text, size = _a.size, marginless = _a.marginless, iconName = _a.iconName, onClick = _a.onClick;
    return (React.createElement(StyledDynamicButton, { marginless: marginless, alingSelf: alingSelf, onClick: function () { return onClick(); }, implicitAction: implicitAction, size: size },
        iconName && React.createElement(FontAwesomeIcon, { icon: iconName }),
        text));
};
var StyledDynamicButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  align-self: ", ";\n\n  > svg {\n    margin-right: 10px;\n  }\n  background-color: ", ";\n\n  color: ", ";\n\n  padding: ", ";\n\n  border: thin solid;\n  border-color: ", ";\n\n  border-radius: ", ";\n\n  margin: ", ";\n\n  &:hover {\n    cursor: pointer;\n    color: ", ";\n\n    background-color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  white-space: nowrap;\n  align-self: ", ";\n\n  > svg {\n    margin-right: 10px;\n  }\n  background-color: ", ";\n\n  color: ", ";\n\n  padding: ", ";\n\n  border: thin solid;\n  border-color: ", ";\n\n  border-radius: ", ";\n\n  margin: ", ";\n\n  &:hover {\n    cursor: pointer;\n    color: ", ";\n\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), function (props) {
    switch (props.alingSelf) {
        case "none":
            return "none";
        case "start":
            return "flex-start";
        default:
            return "none";
    }
}, function (props) {
    switch (props.implicitAction) {
        case "go":
            return function (_a) {
                var theme = _a.theme;
                return theme.go;
            };
        case "stop":
            return function (_a) {
                var theme = _a.theme;
                return theme.stop;
            };
        case "wait":
            return function (_a) {
                var theme = _a.theme;
                return theme.wait;
            };
        case "general":
            return function (_a) {
                var theme = _a.theme;
                return theme.primarioHover;
            };
        case "cancel":
            return function (_a) {
                var theme = _a.theme;
                return theme.cancel;
            };
        case "none":
            return "white";
        case "inert":
            return "white";
        default:
            return "none";
    }
}, function (props) {
    switch (props.implicitAction) {
        case "go":
            return "white";
        case "stop":
            return "white";
        case "wait":
            return "white";
        case "none":
            return function (_a) {
                var theme = _a.theme;
                return theme.primarioHover;
            };
        case "cancel":
            return "white";
        case "inert":
            return "black";
        default:
            return "white";
    }
}, function (props) {
    switch (props.size) {
        case "medium":
            return "10px 15px";
        case "small":
            return "6px 10px";
        default:
            return "0";
    }
}, function (props) {
    switch (props.implicitAction) {
        case "go":
            return function (_a) {
                var theme = _a.theme;
                return theme.go;
            };
        case "stop":
            return function (_a) {
                var theme = _a.theme;
                return theme.stop;
            };
        case "wait":
            return function (_a) {
                var theme = _a.theme;
                return theme.wait;
            };
        case "none":
            return function (_a) {
                var theme = _a.theme;
                return theme.primarioHover;
            };
        case "cancel":
            return function (_a) {
                var theme = _a.theme;
                return theme.cancel;
            };
        case "inert":
            return "#ccc";
        default:
            return "none";
    }
}, function (props) { return props.theme.buttonBorderRadius; }, function (props) {
    if (props.marginless === true) {
        return 0;
    }
    else {
        switch (props.size) {
            case "big":
                return "10px";
            case "medium":
                return "5px 0";
            case "small":
                return "5px";
            default:
                return "0";
        }
    }
}, function (props) {
    switch (props.implicitAction) {
        case "go":
            return "white";
        case "stop":
            return "white";
        case "wait":
            return "white";
        case "none":
            return "white";
        case "cancel":
            return "white";
        case "inert":
            return "black";
        default:
            return "white";
    }
}, function (props) {
    switch (props.implicitAction) {
        case "go":
            return function (_a) {
                var theme = _a.theme;
                return theme.goOscuro;
            };
        case "stop":
            return function (_a) {
                var theme = _a.theme;
                return theme.stopOscuro;
            };
        case "wait":
            return function (_a) {
                var theme = _a.theme;
                return theme.waitOscuro;
            };
        case "none":
            return function (_a) {
                var theme = _a.theme;
                return theme.primario;
            };
        case "cancel":
            return function (_a) {
                var theme = _a.theme;
                return theme.cancelOscuro;
            };
        case "inert":
            return "#ccc";
        default:
            return "none";
    }
}, function (props) {
    switch (props.implicitAction) {
        case "go":
            return function (_a) {
                var theme = _a.theme;
                return theme.goOscuro;
            };
        case "stop":
            return function (_a) {
                var theme = _a.theme;
                return theme.stopOscuro;
            };
        case "wait":
            return function (_a) {
                var theme = _a.theme;
                return theme.waitOscuro;
            };
        case "none":
            return function (_a) {
                var theme = _a.theme;
                return theme.primario;
            };
        case "cancel":
            return function (_a) {
                var theme = _a.theme;
                return theme.cancelOscuro;
            };
        case "inert":
            return "black";
        default:
            return "none";
    }
});
export default DynamicButton;
var templateObject_1;
